$(document).ready(function($) {
    // $('.tabs a').on('click', function(e){
      console.log('.tabs a');
    $('#tabs-cnt.tabs a').on('click', function(e){
       if(!$(this).hasClass('prevent'))
           e.preventDefault();
           var tab = $(this).attr('href');
           $('.tabs a').removeClass('active');
           $(this).addClass('active');
           $('.tab-cnt').hide();
           $(tab).fadeIn(300);
           lineWidth = $(this).width();
           var thisLeft = $(this).position().left;
           $('.red-line').css({'width': lineWidth, 'left': thisLeft});
       });
   // console.log("typeof window.misc();", window.misc())
   // window.misc();

   // Update product image when thumbnail below is clicked, exept when the 360 degree iamnges thumb is clicked.
   $('.pagination-thumbs ul li a').not('li.threesixty_thumb a').on('click', function (e) {
       e.preventDefault();
       var styleTagContent = $(this).attr('style');
       console.log(styleTagContent);
       $('.main-photo').attr('style', styleTagContent);
   });

   // From misc.js
   var product;
   var w = $('.main-photo').width();
   var h = $('.main-photo').height();

       $('.product-banner .banner-left .pagination-thumbs ul li a').on('click', function(e) {
           e.preventDefault();
         
           var photo = $(this).data('photo');
           
           $('.product-banner .banner-left .pagination-thumbs ul li').removeClass('active');
           
           // console.log("$('.product-banner .banner-left .pagination-thumbs ul li').length", $('.product-banner .banner-left .pagination-thumbs ul li').length)
           // console.log("$(this).parent()", $(this).parent())
           
           $(this).parent().addClass('active');
           if (photo == 'thisisthreesixty') {
               $('.main-photo').hide();  
               $('.threesixtywrapper').show();
               // console.log("$('.threesixtywrapper').length", $('.threesixtywrapper').length);
               // console.log("$('#myTurntable').length", $('#myTurntable').length);
               // console.log("$('#myTurntable')", $('#myTurntable'));
               // console.log("$('.main-photo')", $('.main-photo'));
               // console.log("typeof $('#myTurntable').turntable()", typeof $('#myTurntable').turntable());
               // $('#myTurntable')
               $('.main-photo').hide();

               // console.log("$('#myTurntable ul')", $('#myTurntable ul').length)
               // console.log("$('#myTurntable ul')", $('#myTurntable ul'))
               // console.log("$('#myTurntable li')", $('#myTurntable li'))
               // $('#myTurntable ul li').map((index, el) => console.log($(el.target).data('img-src')))
               // $('#myTurntable ul li').map((index, el) => console.log($(el).data('img-src')))
               // $('#myTurntable ul li').map((index, el) => console.log(el))

               try {
                 $('#myTurntable').turntable();
               } catch (err) {
                 console.error("Turntable initialization error:", err);
                 console.log("Turntable element:", $('#myTurntable'));
               }                
               // $('#myTurntable').turntable();
             
               
           } else {
               $('.main-photo').show();
               $('.threesixtywrapper').hide();
               $('.main-photo').html('');
               $('.main-photo').css('background', 'url(' + photo + ') 50% no-repeat');
           }
       });

     if ($('.threesixtywrapper').length) {
         $('.threesixtywrapper').height(h);
         $('.threesixtywrapper').width(w);
     }

     // From main.js
 // Submenu
               var config = {
                   over: function () {
                       $(this).children('.submenu').slideDown(300);
                   },
                   timeout: 800,
                   out: function () {
                       $(this).children('.submenu').slideUp(300);
                   }
               };

               function submenu(){
                   // $(".nav-middle-left .parent").hoverIntent(config);
               }
               submenu();
               // misc();

               var w = $(window).width();
               // Hamburger Menu
               (function() {
                 // Hide/show mobile menu
                   $(".header .hamburger").click(function (e) {
                     if ($("header .hamburger").hasClass("open")) {
                       console.log('removing html.menu-open')
                       $("html").removeClass("menu-open"); // Added this
                     } else {
                       console.log('adding html.menu-open')
                       $(".mobile-topnav").slideDown(300);
                       $("html").addClass("menu-open");
                     }
                   });

                   $('.hamburger').on('click', function(e){
                       e.preventDefault();
                       e.stopPropagation();
                       console.log("$('.hamburger').hasClass('open')", $('.hamburger').hasClass('open'))
                       
                       if (!$('.hamburger').hasClass('open')){
                           $('.mobile-topnav').slideDown(300);
                           $('.hamburger').addClass('open');
                           $('.hamburger').addClass('is-active');
                       } else {
                           $('.mobile-topnav').slideUp(300);
                           $('.hamburger').removeClass('open');
                           $('.hamburger').removeClass('is-active');
                       }
                   });
                   $(window).resize(function(){
                       if(w !== $(window).width()){
                           $('.mobile-topnav').slideUp(300);
                           $('.hamburger').removeClass('open');
                           $('.hamburger').removeClass('is-active');
                       }
                   });
                   $(window).resize(function (e) {
                     $(".mobile-topnav").slideUp(300);
                     $(".mobile-topnav .row").addClass("d-none");
                     $("html").removeClass("menu-open");
                     $(".mob-products-mobile").removeClass("d-none");
                   })

                   $(".mobile-topnav .back").click(function (e) {
                     $(".mobile-topnav").slideUp(300);
                     $(".mobile-topnav .row").addClass("d-none");
                   });

                   
                   if ($('.mobile-header .menu-header > .menu-item-has-children > .sub-menu span.arrow_back').length === 0) {
                       $('.mobile-header .menu-header > .menu-item-has-children > .sub-menu').prepend('<span class="arrow_back"><svg id="Layer" enable-background="new 0 0 64 64" height="30px" viewBox="0 0 64 64" width="35" xmlns="http://www.w3.org/2000/svg"><path fill="#ffffff" d="m54 30h-39.899l15.278-14.552c.8-.762.831-2.028.069-2.828-.761-.799-2.027-.831-2.828-.069l-17.448 16.62c-.755.756-1.172 1.76-1.172 2.829 0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552.528 0 1.056-.208 1.449-.621.762-.8.731-2.065-.069-2.827l-15.342-14.552h39.962c1.104 0 2-.896 2-2s-.896-2-2-2z"></path></svg>Back</span>');
                   }
                   
                   $('.mobile-header .menu-header > .menu-item-has-children > a').removeAttr("href");
                   $('.mobile-header .menu-header > .menu-item-has-children > a, .mobile-header .menu-header > .menu-item-has-children > button').click(function () {
                       $(this).parent().addClass('active');
                       $('.mobile-header .menu-item-has-children.active > .sub-menu').addClass('active');
                       $(this).attr('aria-expanded', 'true');
                   })

                   $('.arrow_back').on('click', function(e){
                       console.log("ESO");
                       var $activeSub = $('.mobile-header .menu-header>.menu-item-has-children>.sub-menu.active');
                       $activeSub.parent().children('a, button').attr('aria-expanded', 'false');
                       $activeSub.removeClass('active');
                   });    

                   $('#primary-menu > .dropdown').on('mouseenter focusin', function () {
                       $(this).children('button.dropdown-toggle').attr('aria-expanded', 'true');
                   }).on('mouseleave focusout', function () {
                       $(this).children('button.dropdown-toggle').attr('aria-expanded', 'false');
                   });
               
               })();

// ---------------------------------------
 
               // Mobile Search
               (function() {
                   $('.mobile-search').on('click', function(e){
                     console.log('.mobile-search clicked')
                       e.preventDefault();
                       if ($(this).hasClass('open')){
                           $(this).removeClass('open');
                           $(this).attr('aria-expanded', 'false');
                           $('.mobile-search-cnt').slideUp(300);
                       } else {
                           $(this).addClass('open');
                           $(this).attr('aria-expanded', 'true');
                           $('.mobile-search-cnt').slideDown(300);
                       }
                   });
               })();

               // Scroll To
               (function() {
                   $('.scrollto').on('click', function(e){
                       e.preventDefault();
                       var section = $(this).attr('href');
                       $('html, body').animate({
                           scrollTop: $(section).offset().top-120
                       }, 1000);
                   });
               })();

               // Toggle
               (function() {
                   $('.toggle').on('click', function(e){
                       e.preventDefault();
                       if ($(this).hasClass('open')){
                           $(this).removeClass('open');
                           $(this).next().slideUp(300);
                       } else {
                           $(this).next().slideDown(300);
                           $(this).addClass('open');
                       }
                   });
               })();
     

     function secondaryMenuInitializer(){
           $('.mobile-topnav a.back, .mobile-topnav-hidden a.front').click(function(e){
               e.preventDefault();
               if($('.nav-middle').hasClass('showfront'))
                   $('.nav-middle').removeClass('showfront');
               else
                   $('.nav-middle').addClass('showfront');
               console.log('clcking');
           });
       }
       $('.nav-middle-left>li.parent').mouseover(function(){
           $(this).addClass("opensubmenu");
           $(this).children('.submenu').slideDown(200);
       });
       $('.submenu').mouseover(function(){
           $(this).slideDown(200);
       });
       secondaryMenuInitializer();
       function initializeFilters() {
           $('#sidebar-filters  .filter-this li input').click(function(e){
               // if ($(this).is(':checked')){
               // } else {
                   // $(this).prop('checked', false);
               // }
                   $('body').addClass('filtering');
                   var tax = $(this).attr('data-tax');
                   if($(this).hasClass('parent')){
                       $('#' + tax +' li.has-children ul li input[type="checkbox"]').prop('checked' , false);
                   } else {
                       $('#' + tax +' li.has-children input.parent[type="checkbox"]').prop('checked' , false);
                   }
                   var a = [];
                   $('#main-filters-wrapper #'+tax+' input:checked').each(function(e){
                       a.push($(this).attr('data-id'));
                   });
                   var ids = a.join(',');
                   setHistory(ids, tax, 'add');
           });
           $('.sidebar .has-children .ico').on('click', function(e){
               if ($(this).parent().hasClass('open')){
                   $(this).prev().prev().slideUp(300);
                   $(this).parent().removeClass('open');
               } else {
                   $(this).prev().prev().slideDown(300);
                   $(this).parent().addClass('open');
               }
           });
           $('.sidebar .sidebar-group h4').on('click', function(e){
               if ($(this).hasClass('open')){
                   $(this).parent().next().slideUp(300);
                   $(this).removeClass('open');
               } else {
                   $(this).parent().next().slideDown(300);
                   $(this).addClass('open');
               }
           });
       }
       function initializeRemover() {
           $('#filter-results li a').click(function(e){
               e.preventDefault();
               var tax = $(this).attr('data-tax');
               if(tax == 's'){
                   setHistory('', 's');
               } else {
                   var id = $(this).attr('data-id');
                   $('#'+tax+'_'+id).click();
               }
           });
       }
       function reinitialize(){
           initializeRemover();
           initializeFilters();
       }
       reinitialize();
       function setHistory(id, posttype, addorremove){
           var curUrl = window.location.href;
           // if(posttype == undefined){
               // window.history.replaceState( {} , null, '?paged='+id );
           // } else {
               var variables = getUrlVars();
               if(curUrl.indexOf('?') > 0) {
                   if(variables[posttype] == undefined)
                       window.history.replaceState( {0:variables} , null, curUrl+'&'+posttype+'='+id );
                   else
                       window.history.replaceState( {0:variables} , null, updateQueryStringParameter(curUrl, posttype, id) );
               } else {
                   window.history.replaceState( {} , null, '?'+posttype+'='+id+'&s=' );
               }
           // }
           if($('body').hasClass('internetexplorer'))
                   window.location = window.location;
           else
               updateProducts(window.location.href);
       }
       function getUrlVars()
       {
           var vars = [], hash;
           var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
           for(var i = 0; i < hashes.length; i++)
           {
               hash = hashes[i].split('=');
               vars.push(hash[0]);
               vars[hash[0]] = hash[1];
           }
           return vars;
       }
       function updateQueryStringParameter(uri, key, value) {
           var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
           var separator = uri.indexOf('?') !== -1 ? "&" : "?";
           if (uri.match(re)) {
               return uri.replace(re, '$1' + key + "=" + value + '$2');
           } else {
               return uri + separator + key + "=" + value;
           }
       }
       function updateProducts(u){
           $.ajax({
               url: u
           }).done(function(data){
               console.log('data', data);
               var mainfilters = $(data).find('#main-filters-wrapper').html();
               var resultstotal = $(data).find('#results-total').html();
               var filterresults = $(data).find('#filter-results').html();
               var productsinnerwrapper = $(data).find('#products-inner-wrapper').html();
               var pagination = $(data).find('#product-pagination').html();
               $('#main-filters-wrapper').html(mainfilters);
               $('#results-total').html(resultstotal);
               $('#filter-results').html(filterresults);
               $('#products-inner-wrapper').html(productsinnerwrapper);
               $('#product-pagination').html(pagination);
               reinitialize();
               $('body').removeClass('filtering');
           });
       }
       function nolinker(){
           $('.no-link').click(function(e){
               e.preventDefault();
           });
       }
       nolinker();

       $('.bio-popup .prev').click(function(e){
           e.preventDefault();
           var whoaw = $('#popup-detail-container').attr('data-currentwrapper');
           $('.look-at-me-now.'+whoaw+'.active').prev('.look-at-me-now').find('a.link').click();
       });
       $('.bio-popup .next').click(function(e){
           e.preventDefault();
           var whoaw = $('#popup-detail-container').attr('data-currentwrapper');
           $('.look-at-me-now.'+whoaw+'.active').next('.look-at-me-now').find('a.link').click();
           console.log(whoaw);
       });
       $('.map-banner .map .marker').click(function(e){
           e.preventDefault();
           var whoaw = $(this).attr('data-toTarget');
           $('.box').removeClass('red-my-mind');
           $('#'+whoaw).addClass('red-my-mind');
           $('html, body').animate({
               scrollTop: $("#"+whoaw).offset().top - 200
           }, 1000);
           // console.log(whoaw);
       });

       var product;
       var w = $('.main-photo').width();
       var h = $('.main-photo').height();

       $('.product-banner .banner-left .pagination-thumbs ul li a').on('click', function(e){
           e.preventDefault();
           var photo = $(this).data('photo');
           $('.product-banner .banner-left .pagination-thumbs ul li').removeClass('active');
           $(this).parent().addClass('active');
           if(photo == 'thisisthreesixty'){
               $('.threesixtywrapper').show();
               $('#myTurntable').turntable();
               $('.main-photo').hide();
           } else {
               $('.main-photo').show();
               $('.threesixtywrapper').hide();
               $('.main-photo').html('');
               $('.main-photo').css('background', 'url('+photo+') 50% no-repeat');
           }
       });

       if($('body').hasClass('single-product') && $('.threesixtywrapper').length){
           $('.threesixtywrapper').height(h);
           $('.threesixtywrapper').width(w);
           // $('#myTurntable').turntable();
       }
       if($('body').hasClass('single-post')){
           singleScroller();
       }
       // jQuery(window).resize(function(){
           // singleScroller();
       // });
       function singleScroller(){
           if($(window).width() > 768){
               $(window).scroll(function(){
                   var s = $(window).scrollTop();
                   var bottom = $('body').height() - ($('section.section.updates').height() + $('footer.footer').height() + 400);
                   var b = $('.scroll-wrapper').height() - $('.single-share').height();
                   console.log(s);
                   console.log(bottom);
                   if(s > 480 && s < bottom){
                       $('.single-share').addClass('stickwitu');
                       $('.single-share').css('top', s - 480);
                   } else if(s >= bottom) {
                       $('.single-share').addClass('stickwitu');
                       $('.single-share').css('top', b);
                   } else {
                       $('.single-share').removeClass('stickwitu');
                   }
               })
           }
       }

    // Slick slider on brand page
    $('.video-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        asNavFor: '.video-slider-nav'
    });
  
    $('.video-slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.video-slider',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        arrows: false,
        responsive: [
            {
            breakpoint: 768,
                settings: {
                    arrows: true,
                    centerMode: false,
                    centerPadding: '40px',
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
            breakpoint: 480,
                settings: {
                    arrows: true,
                    centerMode: false,
                    centerPadding: '40px',
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
  });
  
  $(".video-slider-nav .pad-the-video").attr('disabled','disabled');

// Add to cart button to form on product pages
$('.add-to-cart-form-button').on('click', function (e) {
  e.preventDefault();
  const productHandle = $(this).data('product');
  const productTitle = $(this).data('title');
  const productSKU = $(this).data('sku');

  if (productHandle) {
    // Get existing cart or create an empty array
    let cart = JSON.parse(localStorage.getItem('quote-cart')) || [];
    let feedbackMessage = '';

    // Check if product is already in cart
    const productInCart = cart.find(item => item.handle === productHandle);

    if (!productInCart) {
      // Add product object to cart with quantity 1
      cart.push({ handle: productHandle, title: productTitle, sku: productSKU, quantity: 1 });
      feedbackMessage = 'Product was added to your quote cart.';
    } else {
      // Increment the quantity of the existing product in the cart
      productInCart.quantity += 1;
      feedbackMessage = 'Product quantity was updated in your quote cart.';
    }

    // Save back to localStorage
    localStorage.setItem('quote-cart', JSON.stringify(cart));

    // Show toast notification
    showToast(feedbackMessage);
  }
});

// Function to display the toast
function showToast(message) {
  // Check if a toast is already visible
  let $existingToast = $('.toast-notification');
  if ($existingToast.length > 0) {
    $existingToast.remove(); // Remove existing toast if any
  }

  // Create toast element
  const $toast = $(`
    <div class="toast-notification">
      ${message}
    </div>
  `);

  // Append to body
  $('body').append($toast);

  // Animate toast in
  $toast.fadeIn(300);

  // Auto-hide after 3 seconds
  setTimeout(() => {
    $toast.fadeOut(300, () => {
      $toast.remove();
    });
  }, 3000);
}


});

// window.addEventListener("scroll", function(){
//     var header = document.getElementById("header-navbar");
//     header.classList.toggle("sticky", window.scrollY > 115);
// })
const header = document.querySelector('header');
const sticky_cta = document.querySelector('.core-sticky-cta') 
let lastScroll = window.scrollY;
const threshold = 10;

window.addEventListener('scroll', () => {
  const currentScroll = window.scrollY;

  if (currentScroll <= 0) {
    header.classList.remove('menu-invisible');
    lastScroll = currentScroll;
    return;
  }

  if (Math.abs(currentScroll - lastScroll) < threshold) {
    return;
  }

  if (currentScroll > lastScroll) {
    header.classList.add('menu-invisible');
    if(currentScroll >= 600 && window.innerWidth > 768 ){
      sticky_cta.classList.remove('hidden');
    }
    if(currentScroll >= 1100 && window.innerWidth < 768 ){
      sticky_cta.classList.remove('hidden');
    }
  } else {
    header.classList.remove('menu-invisible');
    if(currentScroll <= 500  && window.innerWidth > 768 ){
      sticky_cta.classList.add('hidden');
    }
    if(currentScroll <= 1100 && window.innerWidth < 768 ){
      sticky_cta.classList.add('hidden');
    }
  }

  lastScroll = currentScroll;
});
